const FilterDropdownMenuWrapper = (_props, { slots }) => {
    var _a;
    return (<div onClick={e => e.stopPropagation()}>{(_a = slots.default) === null || _a === void 0 ? void 0 : _a.call(slots)}</div>);
};
export default FilterDropdownMenuWrapper;
